// U-12 (UX-4): přepínač světlý/tmavý režim přes Bootstrap 5.3 nativní data-bs-theme na <html>.
// BS 5.3 automaticky přepne hodnoty všech --bs-* proměnných → komponenty i naše modulové CSS (které
// čte z --bs-*) se přebarví samy. Volba se persistuje v localStorage ('digidesk-theme').
// FOUC-safe init je INLINE v <head> (_LayoutHead.cshtml) — modul je async, sám by světlý probliknul.
// Tenhle modul jen obsluhuje klik přepínače (#s-theme-toggle v _Sidebar.cshtml) a drží ikonu se stavem.

const STORAGE_KEY = 'digidesk-theme';

// ikona: měsíc = teď je světlo (klikni pro tmu), slunce = teď je tma (klikni pro světlo)
function updateThemeIcon() {
    const isDark = document.documentElement.getAttribute('data-bs-theme') === 'dark';
    const icon = document.querySelector('#s-theme-toggle i');
    if (icon)
        icon.className = isDark ? 'fa fa-sun' : 'fa fa-moon';
}

// okamžité přepnutí (jen atribut na <html>, žádný reload) + persistence
export function toggleTheme() {
    const html = document.documentElement;
    const isDark = html.getAttribute('data-bs-theme') === 'dark';
    if (isDark) {
        html.removeAttribute('data-bs-theme'); // světlý = default BS (žádný atribut)
        try { localStorage.setItem(STORAGE_KEY, 'light'); } catch { /* ignore */ }
    }
    else {
        html.setAttribute('data-bs-theme', 'dark');
        try { localStorage.setItem(STORAGE_KEY, 'dark'); } catch { /* ignore */ }
    }
    updateThemeIcon();
}

// wiring přepínače v horní liště; idempotentní (guard data-init). Vzor initQuickCreateButton (ScriptInit).
export function initThemeToggle() {
    const btn = document.getElementById('s-theme-toggle');
    if (!btn || btn.dataset.init === '1')
        return;
    btn.dataset.init = '1';
    btn.addEventListener('click', e => { e.preventDefault(); toggleTheme(); });
    updateThemeIcon(); // sladit ikonu se stavem z inline initu v <head>
}
